import { Component, Input, OnInit } from '@angular/core';
import dayjs from 'dayjs';

import { BonusInformation } from '@app/core/model/configuration.model';
import { BonusStatByMonth, IDriverStats } from '@app/core/model/qualifications.model';
import { IBonusQualificationService } from '@app/core/services/interface/IBonusQualificationService';
import { IConfigurationService } from '@app/core/services/interface/IConfigurationService';
import { ServiceFactory } from '@app/core/services/service.factory';
import { AuthService } from '@app/core/auth.service';

@Component({
  selector: 'app-wig-bonus-summary',
  templateUrl: './wig-bonus-summary.component.html',
  styleUrls: ['./wig-bonus-summary.component.css'],
})
export class WigBonusSummaryComponent implements OnInit {
  @Input() bonusInformation: BonusInformation[];
  @Input() bonusStat: BonusStatByMonth;
  @Input() currentPeriod: Date;
  @Input() paymentType: string;
  @Input() qualifyPeriod: Date;
  bonusQualificationService: IBonusQualificationService;
  configurationService: IConfigurationService;
  description: string;
  driverStat: IDriverStats;
  isLoadingDriverStat: boolean;
  isSidebarVisible: boolean;
  sideBarTitle: string;
  status: string;

  constructor(private authService: AuthService, serviceFactory: ServiceFactory) {
    this.bonusQualificationService = serviceFactory.getBonusQualificationService();
    this.isLoadingDriverStat = true;
    this.isSidebarVisible = false;
    this.sideBarTitle = '';
  }

  clearSidebar() {
    this.sideBarTitle = '';
  }

  displayIcon() {
    switch (this.bonusStat.icon) {
      case 'sack-dollar':
      case 'thumbs-up':
      case 'exclamation-triangle':
        return true;
      default:
        return false;
    }
  }

  displaySideBar(title: string, status: string) {
    this.isSidebarVisible = true;
    this.sideBarTitle = title;
    switch (title) {
      case 'All Commitments, Huddles, Safety Video':
        this.description = this.bonusInformation.find(
          (x) => x.name === 'Commit_Description'
        ).description;
        break;
      case 'No Accidents or Critical Events':
        this.description = this.bonusInformation.find(
          (x) => x.name === 'Safety_Description'
        ).description;
        break;
      case 'No Late Arrivals':
        this.description = this.bonusInformation.find(
          (x) => x.name === 'OnTime_Description'
        ).description;
        break;
    }
    this.status = this.bonusInformation.find(
      (x) => x.name === status.replace(' ', '_') + '_Status'
    ).description;
  }

  getCommitmentValue1() {
    return (this.driverStat.commitBonusPercentage * this.driverStat.monthProgress) / 100;
  }

  getCommitmentValue2() {
    return this.driverStat.monthProgress;
  }

  getIcon(): string[] {
    switch (this.bonusStat.icon) {
      case 'sack-dollar':
        return ['fal', 'sack-dollar'];
      case 'thumbs-up':
        return ['fal', 'thumbs-up'];
      case 'exclamation-triangle':
        return ['fal', 'exclamation-triangle'];
    }
  }

  getMonth(): string {
    return 'In ' + dayjs(this.qualifyPeriod).format('MMMM');
  }

  getPaymentUnit(): string {
    const total = this.bonusStat.payAmount * 100;

    return `${total}${this.paymentType === '%' ? '%' : ' CPM'}`;
  }

  getProgressValue1(status: string) {
    if (this.currentPeriod === this.qualifyPeriod) {
      return status === 'Missed' ? 0 : this.driverStat.monthProgress;
    } else {
      return status === 'Missed' ? 0 : 100;
    }
  }

  getProgressValue2(status: string) {
    if (this.currentPeriod === this.qualifyPeriod) {
      return status === 'Missed' ? this.driverStat.monthProgress : 0;
    } else {
      return status === 'Missed' ? 100 : 0;
    }
  }

  getStatusClass(status: string) {
    if (status === 'On Track' || status === 'Earned') {
      return 'earned';
    } else if (status === 'Missed') {
      return 'missed';
    } else if (status === 'At Risk') {
      return 'atrisk';
    } else {
      return '';
    }
  }

  IsLineThrough(status: string): string {
    return status === 'Missed' || status === 'At Risk' ? 'line-through ' : '';
  }

  ngOnInit() {
    this.isLoadingDriverStat = true;

    void this.bonusQualificationService
      .getDriverStatsByQualifyPeriod(
        this.authService.getCurrentUser().username,
        this.qualifyPeriod,
        true
      )
      .then((driverStat) => {
        this.driverStat = driverStat;
        this.isLoadingDriverStat = false;
      });
  }
}
